import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_FILTER } from 'src/app/franchise/constant';

const initialState = {
  ...DEFAULT_FILTER,
};

const filter = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilter: (_, { payload }) => ({ ...payload }),
    updateFilter: (state, { payload }) => ({ ...state, ...payload }),
    resetFilter: (_, { payload }) => ({ ...DEFAULT_FILTER, ...payload }),
  },
});

export const { setFilter, resetFilter, updateFilter } = filter.actions;
export default filter.reducer;
